/* eslint-disable */
import { uaParser as userAgent } from '@encarpkg/shared';
import { encarMobileAppCheck } from 'app/libs/app';
import { isBrowser } from 'app/libs/environment';

const encarURL = process.env.REACT_APP_ENCAR_MOBILE;

const mobileAppBridge = function () {
	var webViewName, version, os, app;
	var _APP_INSTALL_URL = `${encarURL}/dw/dw_app_down.do`;
	var toString = function (str) {
		return str == null || str == '' ? '' : str.toString();
	};
	var ua = global.navigator?.userAgent?.toLowerCase();
	var isKitkat = global.navigator?.userAgent?.search('Android 4.4.2') > -1 ? true : false;
	var webViewName = toString(ua?.match(/(webview)_(android|ios)/g));
	var iosJsScheme = 'HybridApp:'; // ios의 메소드를 실행하기위한 javascript Scheme 정보
	if (webViewName != null) {
		os = toString(webViewName.match(/android|ios/g));
	}
	var v = ua?.match(/version(([0-9].{1,}\d+)?)/g);
	if (v != null) {
		version = v.toString().match(/[0-9].{1,}\d+?$/g);
	}
	var appCheck = encarMobileAppCheck();
	var isEncarPartner = ua?.indexOf('encarpartner') > -1 ? true : false;

	var bindAppCallback = function (callback) {
		var name = '_EncarCb' + +new Date();
		window[name] = function () {
			var result = callback.apply(window, arguments);
			setTimeout(function () {
				window[name] = null;
			}, 0);
		};
		/* callback 함수명을 반환합니다. */
		return name;
	};
	// 브라우져에서 앱을 실행시키기위한 함수
	var execMobileApp = function (appScheme, host, queryString) {
		if (appScheme == '' || appScheme == null || appScheme == undefined) {
			appScheme = 'encarapp';
		}
		// 일반 브라우져에서 호출할경우
		// 설치된 엔카 앱을 실행 만약 실행되지않을경우(미설치의 경우) 앱 다운로드 페이지로 이동처리
		if (appCheck.isAndroidBrowser == true) {
			var url =
				'Intent://' +
				host +
				'?' +
				queryString +
				'#Intent;scheme=' +
				appScheme +
				';action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=com.encar.encarMobileApp;end';
			window.location = url;
		} else if (appCheck.isIosBrowser == true) {
			var visitedAt = new Date().getTime();
			setTimeout(function () {
				if (new Date().getTime() - visitedAt < 2000) {
					location.href = 'http://itunes.apple.com/kr/app/id404512755?mt=8';
				}
			}, 500);
			setTimeout(function () {
				//encarapp://goweburl?url=링크주소
				location.href = appScheme + '://goweburl?url=' + decodeURI(decodeURIComponent(queryString));
			}, 0);
		}
	};

	var _isIos2_0_9_LessAppUser = function () {
		if (os == 'ios') {
			var v = version.join('').split('.'),
				vs = 0,
				base = 209;
			vs += v[0] * 100;
			vs += v[1] * 10;
			vs += v[2] * 1;
			return base > vs;
		}
		return false;
	};

	var storage = (function () {
		if (isBrowser && window.localStorage) {
			try {
				window.localStorage.setItem('_test_', 'ok');
				return window.localStorage;
			} catch (e) {}
		}
		return null;
	})();

	var storageName = 'RecentSearchNavigation#data';
	function getRecentItem() {
		try {
			return storage ? JSON.parse(storage.getItem(storageName)) : [];
		} catch (e) {
			return [];
		}
	}

	function removeByKey(array, id) {
		array.some(function (item, index) {
			console.log(item.id);
			if (array[index].id == id) {
				return array.splice(index, 1);
			}
		});
		return array;
	}

	return {
		/**
		 * 플리킹 메뉴 열기
		 */
		openFlickingMenu: function () {
			var prevAndVersion = 2.2;
			var prevIOSVersion = 1.3;
			var presentVersion = parseFloat(version);

			if (os == 'android') {
				if (prevAndVersion >= presentVersion) {
					return true;
				} else {
					window.HybridApp.flickingMenuOpen();
					return false;
				}
			} else {
				if (isNaN(presentVersion) || prevIOSVersion >= presentVersion) {
					return true;
				} else {
					window.location = iosJsScheme + 'openFlickingMenu:파라메터1|파라메터2';
					return false;
				}
			}
		},
		/**
		 * 플리킹 메뉴 닫기
		 */
		closeFlickingMenu: function () {
			if (os == 'android') window.HybridApp.flickingMenuClose();
			else window.location = iosJsScheme + 'flickingMenuClose:파라메터1|파라메터2';
		},
		setMessage: function (num, rgsid, photonum) {
			/**
			 * TODO 이건뭐지? 안드로이드 앱 코드에 없는 함수임.... 확인해보자.
			 */
			if (os == 'android') window.HybridApp.setMessage(num, rgsid, photonum);
			else window.location = iosJsScheme + 'flickingMenuClose:' + num + '|' + rgsid + '|' + photonum;
		},
		/**
		 * WEB 에서 로그아웃 될때 앱에서도 로그아웃 처리될수있도록
		 * 함수를 호출한다.
		 */
		logout: function () {
			try {
				if (isEncarPartner) {
					if (os == 'android') {
						window.Noah?.logout?.();
					}
					if (os == 'ios') {
						window.webkit?.messageHandlers?.logout?.postMessage?.('');
					}
					return;
				}

				if (os == 'android') {
					window.HybridApp.logout();
					window.location.href = `${encarURL}/co/login.do?method=logout`;
				} else if (os == 'ios') {
					window.location = iosJsScheme + 'logout';
				} else {
					window.location.href = `${encarURL}/co/login.do?method=logout`;
				}
			} catch (e) {
				alert(e);
			}
		},
		/**
		 * 로그아웃 후 로그인 창이 열리는 브릿지
		 * 로그인 후에는 전달된 파라미터에 따라 프로세스가 이어진다.
		 */
		logoutAftreLogin: function (jsonParam) {
			try {
				if (isEncarPartner) {
					// 엔카파트너 케이스 24.
					if (os == 'android') {
						window.Noah?.logout?.();
					}
					if (os == 'ios') {
						window.webkit?.messageHandlers?.logout?.postMessage?.('');
					}
					return;
				}

				if (os === 'android') {
					if (userAgent().lessThanAppVersion('6.5.6')) {
						window.HybridApp.logout();
						setTimeout(() => {
							// 올드버전에서는 로그아웃 브릿지의 후동작이 없기 때문에 리로드 처리
							window?.location?.reload();
						}, 500);
					} else {
						window.HybridApp.showLoginPage(JSON.stringify(jsonParam));
					}

					return;
				}

				if (os === 'ios') {
					if (userAgent().lessThanAppVersion('5.5.1')) {
						window.location = iosJsScheme + 'logout';
						setTimeout(() => {
							// 올드버전에서는 로그아웃 브릿지의 후동작이 없기 때문에 리로드 처리
							window?.location?.reload();
						}, 500);
					} else {
						window.webkit?.messageHandlers?.showLoginPage?.postMessage(JSON.stringify(jsonParam));
					}
				}
				return true;
			} catch (e) {
				return false;
			}
		},
		/**
		 * 로그인 화면 호출
		 * 앱의 로그인 화면을 호출하기위한 함수 로그인후 보내고싶은 페이지의 url 을 인자로 넘기면 해당 url로 이동한다.
		 * @parameter backUrl 로그인완료후 호출되어야하는 url 정보
		 * @parameter closeUrl 헤더 닫기버튼 클릭시 호출되어야하는 url
		 */
		login: function (backUrl = '', iphoneAuthCheck, closeUrl = '') {
			try {
				if (backUrl == undefined) backUrl = '';

				if (isEncarPartner) {
					// 엔카파트너는 로그인 브릿지 하나뿐
					if (os == 'android') {
						window.Noah?.login?.();
					}
					if (os == 'ios') {
						window.webkit?.messageHandlers?.login?.postMessage?.('');
					}
					return;
				}

				if (os == 'android') {
					if (userAgent().lessThanAppVersion('5.9.4')) {
						// login브릿지 버전 체크
						window.HybridApp.login(backUrl);
					} else {
						window.HybridApp.login(backUrl, closeUrl);
					}
					return;
				}

				if (os == 'ios') {
					const encodeBackUrl = backUrl ? `:${encodeURIComponent(backUrl)}:encoded` : '';
					const encodeClosekUrl = closeUrl ? `:${encodeURIComponent(closeUrl)}` : '';
					if (userAgent().lessThanAppVersion('4.9.4')) {
						window.location = `${iosJsScheme}login:${iphoneAuthCheck}${encodeBackUrl}`;
					} else {
						window.location = `${iosJsScheme}login:${iphoneAuthCheck}${encodeBackUrl}${encodeClosekUrl}`;
					}

					return;
				}

				return true;
			} catch (e) {
				return false;
			}
		},
		// 로그인시 파라미터를 json형태로 전달하기 위한 함수: login 함수 대체
		loginWithParam: function (jsonParam, iphoneAuthCheck, skipAble) {
			try {
				if (isEncarPartner) {
					// 엔카 파트너 환경에서 호출 대응 (현재는 X)
					if (os == 'android') {
						window.Noah?.login?.();
					}
					if (os == 'ios') {
						window.webkit?.messageHandlers?.login?.postMessage?.(jsonParam?.backUrl || '');
					}
					return;
				}

				// 해당 앱 브릿지 설치되지 않은 이전 버전에선 login 함수 호출
				if (os === 'android') {
					if (userAgent().lessThanAppVersion('6.4.7')) {
						window.HybridApp.login(jsonParam?.backUrl, jsonParam?.closeUrl);
					} else {
						window.HybridApp.loginWithParam(JSON.stringify(jsonParam));
					}
				}

				if (os === 'ios') {
					if (window.webkit?.messageHandlers?.loginWithParam?.postMessage) {
						window.webkit?.messageHandlers?.loginWithParam?.postMessage(JSON.stringify(jsonParam));
						return true;
					}

					const encodeBackUrl = jsonParam?.backUrl ? `${encodeURIComponent(jsonParam?.backUrl)}:encoded` : ':';
					// closeUrl에 destroyWebView 존재시, 네이티브 로그인 페이지 헤더의 X 누를때 밑에 있던 웹뷰를 닫는다.
					// 로그인 성공시 앱브릿지 통해 실행된 로그인 네이티브 뷰는 닫히고, backUrl로 웹뷰에 history.push를 해줌
					// 로그인이 필요한 서비스라면 로그인 성공 후, 흰 웹뷰 / backUrl 웹뷰가 히스토리로 쌓임, 이 때  back 했을때 흰 웹뷰가 안 보이려면 destroyWebView를 loginWithParam 함수에 전달해서 흰 웹뷰를 없애놔야
					const encodecloseUrl = jsonParam?.closeUrl ? encodeURIComponent(jsonParam?.closeUrl) : '';
					const encodeService = jsonParam?.service ? encodeURIComponent(jsonParam?.service) : '';
					window.location = `${iosJsScheme}login:${iphoneAuthCheck}:${encodeBackUrl}:${encodecloseUrl}:${encodeService}`;
				}
				return true;
			} catch (e) {
				return false;
			}
		},
		/**
		 * 엔카아이디로 로그인 화면 호출
		 */
		encarLogin: function (backUrl = '', iphoneAuthCheck, closeUrl = '') {
			try {
				if (backUrl == undefined) backUrl = '';

				if (isEncarPartner) {
					// 엔카 파트너 환경에서 호출 대응 (현재는 X)
					if (os == 'android') {
						window.Noah?.login?.();
					}
					if (os == 'ios') {
						window.webkit?.messageHandlers?.login?.postMessage?.(backUrl || '');
					}
					return;
				}

				if (os == 'android') {
					if (userAgent().lessThanAppVersion('5.9.4')) {
						window.HybridApp.login(backUrl);
					}
					// 2023.10.10 로그인 개편 후 버전 = 6.2.3 (확인필요) <- 이보다 낮을 경우 기존 브릿지
					else if (userAgent().lessThanAppVersion('6.2.3')) {
						window.HybridApp.login(backUrl, closeUrl);
					}
					// 가장 최신 브릿지
					else {
						window.HybridApp.encarLogin(backUrl, closeUrl);
					}
					return;
				}

				if (os == 'ios') {
					const encodeBackUrl = backUrl ? `:${encodeURIComponent(backUrl)}:encoded` : '';
					const encodeClosekUrl = closeUrl ? `:${encodeURIComponent(closeUrl)}` : '';

					if (userAgent().lessThanAppVersion('4.9.4')) {
						window.location = `${iosJsScheme}login:${iphoneAuthCheck}${encodeBackUrl}`;
					}
					// 2023.10.10 로그인 개편 후 버전 = 5.2.0 (확인필요) <- 이보다 낮을 경우 기존 브릿지
					else if (userAgent().lessThanAppVersion('5.2.0')) {
						window.location = `${iosJsScheme}login:${iphoneAuthCheck}${encodeBackUrl}${encodeClosekUrl}`;
					}
					// 가장 최신 브릿지
					else {
						window.location = `${iosJsScheme}encarLogin:${iphoneAuthCheck}${encodeBackUrl}${encodeClosekUrl}`;
					}
					return;
				}

				return true;
			} catch (e) {
				return false;
			}
		},
		/**
		 * 특정 외부 앱을 실행 시키기위한 함수
		 * @parameter packageNm 실행시키기외한 앱 패키지명 ex) 진단팩 앱 실행 : mobileAppBridge.excuteApp('com.encar.inspectPack')
		 */
		excuteApp: function (packageNm) {
			if (os == 'android') window.HybridApp.excuteApp(packageNm);
			else window.location = iosJsScheme + 'excuteApp' + (packageNm == '' ? '' : ':') + packageNm;
		},
		getEncarAppVersion: function () {
			if (version == undefined) return '';
			return version.toString();
		},
		isAndroidKitkat: function () {
			if (isKitkat == undefined) return false;
			return isKitkat;
		},
		androidInputFileCheck: function () {
			var result = false;

			if (os == 'android') {
				var kitkatVersion = 4.4;
				var deviceAgent = global.navigator?.userAgent;
				var andOsVesion = deviceAgent?.match(/Android\s+([\d\.]+)/)[1];
				var floatOsVersion = parseFloat(andOsVesion);

				if (floatOsVersion >= kitkatVersion) {
					result = true;
				} else {
					result = false;
				}
			}
			return result;
		},

		/**
		 * 네이버 라인으로 공유하기 기능
		 * @parameter lineText 라인으로 공유하기위한 텍스트정보
		 */
		goNaverLine: function (lineText) {
			if (os == 'android') window.HybridApp.goNaverLine(lineText);
			else window.location = iosJsScheme + 'goNaverLine:' + lineText;
		},
		/**
		 * 네이버 밴드로 공유하기 기능
		 * @parameter lineText 공유하기위한 텍스트정보
		 */
		goNaverBand: function (bandText) {
			if (os == 'android') window.HybridApp.goNaverBand(bandText);
			else window.location = iosJsScheme + 'goNaverBand:' + bandText;
		},
		/**
		 * 앱 이용중 팝업 윈도우기능 띄우기위한 기능
		 * @parameter url 팝업 윈도우에서 이동하게될 url 정보
		 */
		goNewWindow: function (url) {
			if (os == 'android') {
				window.HybridApp.goNewWindow(url);
			} else if (os == 'ios') {
				window.location = iosJsScheme + 'goNewWindow:' + url;
			} else {
				return window.open(url);
			}
		},

		goExternalPage: function (url) {
			if (os == 'android') {
				window.HybridApp.goNewWindow(url);
			} else if (os == 'ios') {
				// 앱 내에서 외부 url 이동
				webkit.messageHandlers.openExternalBrowser.postMessage(JSON.stringify({ url }));
			} else {
				// 외부 브라우저 오픈(OS 기본 브라우저)
				return window.open(url);
			}
		},

		goADNewWindow: function (url, target) {
			if (!url) {
				return;
			}

			if (!target) {
				target = '_blank';
			}

			try {
				if (os == 'android') {
					window.HybridApp.goADNewWindow(url);
				} else if (os == 'ios') {
					window.location = iosJsScheme + 'goADNewWindow:' + url + ':' + target;
				} else {
					window.open(url, target);
				}
			} catch (e) {
				window.open(url, target);
			}
		},
		/**
		 * 앱 이용중 마이페이지 차량사진 등록,수정 화면 호출
		 * @parameter rgsid 차량 관리키
		 * @parameter dirArr 이미지 확장자포함 저장 경로
		 */
		modcarimg: function (rgsid, dirArr) {
			rgsid = rgsid == undefined ? '' : rgsid;
			dirArr = dirArr == undefined ? '' : dirArr;
			if (os == 'android') window.HybridApp.modcarimg(rgsid, dirArr);
			else window.location = iosJsScheme + 'modcarimg:' + rgsid + ':' + dirArr;
		},
		/**
		 * 앱 이용중 마이페이지 차량사진 등록,수정 화면 호출
		 * @parameter rgsid 차량 관리키
		 */
		regcarimg: function (rgsid) {
			rgsid = rgsid == undefined ? '' : rgsid;
			if (os == 'android') window.HybridApp.regcarimg(rgsid, '');
			else window.location = iosJsScheme + 'regcarimg:' + rgsid;
		},
		/**
		 * 앱 이용중 프로그레스 다이얼로그를 띄우기위한 기능
		 */
		setProgressDialogStyle: function () {
			if (os == 'android') window.HybridApp.setProgressDialogStyle();
			else window.location = iosJsScheme + 'setProgressDialogStyle';
		},
		/**
		 * 네이티브 앱에서 차량 이미지 업로드된 정보를 얻어온다.
		 *
		 */
		getUploadImageData: function () {
			if (os == 'android') window.HybridApp.getUploadImageData();
			else window.location = iosJsScheme + 'getUploadImageData';
		},
		/**
		 * 이미지 업로드완료후 리사이징, 썸네일 생성완료시 토스트메세지를 보여주기위한 함수
		 *
		 */
		showAppToast: function (comment) {
			comment = comment == undefined ? '' : comment;
			if (os == 'android') window.HybridApp.showAppToast(comment);
			else window.location = iosJsScheme + 'showAppToast:' + Base64.encode(comment);
		},
		execEncarApp: function (exeUrl, downloadurl) {
			var appScheme = 'encarapp';
			var host = 'move';
			// 일반 브라우져에서 호출할경우
			// 설치된 엔카 앱을 실행 만약 실행되지않을경우(미설치의 경우) 앱 다운로드 페이지로 이동처리
			if (appCheck.isAndroidBrowser == true) {
				var url =
					'Intent://' +
					host +
					'?' +
					exeUrl +
					'#Intent;scheme=' +
					appScheme +
					';action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=com.encar.encarMobileApp;end';
				window.location.href = url;
				setTimeout(function () {
					if (new Date() - b < 1500) {
						window.location.href = downloadurl;
					}
				}, 500);
			} else if (appCheck.isIosBrowser == true) {
				var visitedAt = new Date().getTime();
				setTimeout(function () {
					if (new Date().getTime() - visitedAt < 2000) {
						location.href = downloadurl;
					}
				}, 500);
				setTimeout(function () {
					//encarapp://goweburl?url=링크주소
					location.href = appScheme + '://goweburl?url=' + decodeURI(decodeURIComponent(exeUrl));
				}, 0);
			}
		},
		callBackSuccess: function (data) {
			if (data.iResult == '0') {
				document.form_ipin.enc_data.value = data.enc_data;
				document.form_ipin.action = 'https://cert.vno.co.kr/ipin.cb';
				document.form_ipin.submit();
			}
		},
		iPin_Submit: function (type) {
			$('checkType').value = 'checkIpin';
			MUserIpinDWR.checkIpin($('pageid').value, '', '', type, this.callBackSuccess);
		},
		checkplusCheck: function () {
			jQuery('checkType').value = 'checkName';
			window.name = 'Parent_window';
			document.ck_checkName.action = 'https://check.namecheck.co.kr/mobile2/checkplus.cb';
			document.ck_checkName.submit();
		},
		regCar: function () {
			var scheme = 'encarapp';
			var host = 'move';
			var url = `${encarURL}/rs/regself_v.do`;

			if (appCheck.isApp == true) {
				if (regCarVersionCheck() == false) {
					return;
				}
				if (getIsNotHashkey() == true) {
					// 미인증회원 : isApp 다음에 처리해야함. : 미인증시 레이어 팝업 재생
					mLayerFc('.layer_cetify');
					return false;
				}
				window.location.href = url;
			} else {
				if (appCheck.isAndroidBrowser == true) {
					host = 'rs_sell';
					url = 'key=' + url;
				} else if (appCheck.isIosBrowser == true) {
				} else {
					alert('셀프등록은 안드로이드/iOS 모바일 앱에서 이용하실 수 있습니다.');
					window.location.href = 'https://m.encar.com/dw/dw_app_down.do';

					return;
				}
				execMobileApp(scheme, host, url);
			}
		},
		/**
		 * 기본적으로 앱에서만 서비되는 메뉴의경우 사용함수
		 * 현재 앱사용중 여부 및 앱 설치여부를 체크해서 동작한다.
		 */
		goUrlApp: function (appScheme, url) {
			// 호출된 페이지가 app 안에 있을경우 호출하지 않고 전달받은 url로 이동처리
			// 전달받은 url정보가없을경우 아무 동작 하지않음.
			if (appCheck.isApp == true) {
				if (url != undefined && url != '') {
					window.location.href = url;
				}
				return;
			}

			// 일반 브라우져에서 호출할경우
			// 설치된 엔카 앱을 실행 만약 실행되지않을경우(미설치의 경우) 앱 다운로드 페이지로 이동처리
			if (appCheck.isAndroidBrowser == true || appCheck.isIosBrowser == true) {
				execMobileApp(appScheme, 'move', url);
			} else {
				alert('안드로이드, 아이폰 기기에서 이용 가능합니다.');
				return;
			}
			return;
		},
		/**
		 * 최근 검색조건 데이터 전송
		 */
		searchOptionData: function (searchOptionDataList, callback) {
			// :APP
			if (os in { android: 1, ios: 1 }) {
				// 검색 개편
				var checkVersion = 2.6;
				var presentVersion = parseFloat(version);
				if (os == 'android') {
					checkVersion = 2.6;
				} else {
					// ios
					checkVersion = 2.2;
				}

				var optionData = JSON.stringify(searchOptionDataList.slice(0, 3)); // 앱에 전달은 3개만 합니다.
				if (checkVersion <= presentVersion) {
					optionData = JSON.stringify(searchOptionDataList); // 전체 전달
				}
				// 검색개편 끝

				if (os == 'android') {
					var prevVersion = 2.3;
					var presentVersion = parseFloat(version);
					if (prevVersion <= presentVersion) {
						try {
							window.HybridApp.searchOptionData(optionData, bindAppCallback(callback));
							return;
						} catch (e) {
							console.error(e);
						}
					}
				}
				// ios
				else {
					var callbackName = bindAppCallback(callback);
					setTimeout(function () {
						typeof window[callbackName] === 'function' && window[callbackName]();
					}, 1500);
					/*2.0.9 아이폰 앱이 검수 통과하기 전까진 */
					try {
						window.location =
							iosJsScheme + 'searchOptionData:' + callbackName + ':' + Base64.encode(_isIos2_0_9_LessAppUser() ? '[]' : optionData);
					} catch (err) {
						alert('ERROR :' + err.message);
					}
					return;
				}
				setTimeout(function () {
					callback();
				}, 500);
			} else {
				// :WEB
				callback();
			}
		},
		/**
		 * 광고 관련
		 */
		ad: {
			/**
			 * 광고 캡션명 가져오기 (매번 바뀌지 않기 때문에 처음 한번만 가져오면 됨)
			 * ex) mobileAppBridge.ad.name('menu_insu')
			 */
			name: function (type) {
				if (AdBanner) return AdBanner.name(type);
				return '';
			},
			/**
			 * 광고 클릭시 동작 (click event에 호출만 하면 됨)
			 * ex) mobileAppBridge.ad.link('menu_insu')
			 */
			link: function (type, link) {
				if (AdBanner) return AdBanner.link(type, link);
			},
			/**
			 * 메뉴 확장시 호출(노출수 증가를 위함)
			 * ex) mobileAppBridge.ad.refresh()
			 */
			refresh: function () {
				if (AdBanner) return AdBanner.refresh();
			},
		},
		/**
		 * @function 아이폰앱이면서 2.0.9 이하 버전 사용자인지 여부 반환한다.
		 * 		아이폰 앱 등록 Reject으로 인하여 기존 앱 사용자들의 최근검색조건을 날려야 한다. v2.0.9 이하일때만
		 * */
		isIos2_0_9_LessAppUser: _isIos2_0_9_LessAppUser,
		appImgUpload: function (rgsid, url) {
			if (os == 'android') {
				window.HybridApp.imgFileKikatUpload(rgsid, url);
			}
		},
		/**
		 * 차량 사진 업로드를 위한 Function
		 * @param carid
		 * @param funcOld
		 * @returns {boolean}
		 */
		appCaridPhotoUpload: function (carid, funcOld) {
			var appVersion = this.getEncarAppVersion();
			appVersion = parseInt(appVersion.replace(/\./gi, ''), 10);
			var flagAppV = false;
			var checkVersion;
			if (os == 'android') {
				checkVersion = '4.1.6';
			} else {
				checkVersion = '3.0.9';
			}
			checkVersion = parseInt(checkVersion.replace(/\./gi, ''));
			if (appVersion < checkVersion) {
				funcOld();
			} else {
				if (os == 'android') {
					window.HybridApp.photoUploadByCarid(carid);
				} else {
					window.location = iosJsScheme + 'photoUploadByCarid:' + carid;
				}
				return false;
			}
		},

		setTopBarContent: function (title, image) {
			// 올타에서만 실행하도록
			if (/alltire/.test(ua)) {
				title = encodeURIComponent(title);
				image = encodeURIComponent(image);
				if (os == 'android') {
					window.HybridApp.setTopBarContent('TITLE', title, image);
					return false;
				} else {
					window.location = iosJsScheme + 'setTopBarContent:' + title + ':' + image;
					return false;
				}
			}
		},
		deviceDataUpdate: function (phonenum, referrer) {
			var prevIOSVersion = 1.3;
			var presentVersion = parseFloat(version);

			if (os == 'android') {
				var appVersion = (version + '').replace(/\./gi, '');

				var checkVersion = '4.4.6'.replace(/\./gi, '');

				if (appVersion < checkVersion) {
					window.HybridApp.deviceDataUpdate(phonenum);
				} else {
					window.HybridApp.deviceDataUpdate(phonenum, referrer);
				}
			} else {
				if (isNaN(presentVersion) || prevIOSVersion >= presentVersion) {
					return true;
				} else {
					window.location = iosJsScheme + 'deviceDataUpdate:' + phonenum + ':' + referrer;
					return false;
				}
			}
		},
		getPhoneNumber: function (phonenum) {
			var prevIOSVersion = 1.3;
			var presentVersion = parseFloat(version);

			if (os == 'android') {
				window.HybridApp.getPhoneNum(phonenum);
			} else {
				if (isNaN(presentVersion) || prevIOSVersion >= presentVersion) {
					return true;
				} else {
					window.location = iosJsScheme + 'getPhoneNum:' + phonenum;
					return false;
				}
			}
		},
		getAppCarInfo: function (rgsid, userid, sellernum, appWtHit) {
			let wtHitCase;
			// 0=하단버튼, 1=레이어팝업
			switch (appWtHit) {
				case 'ca_car':
					wtHitCase = '0';
					break;
				case 'ca_car_pop':
					wtHitCase = '1';
					break;
				default:
					wtHitCase = appWtHit;
			}
			const prevAndVersion = '5.5.4'.replace(/\./gi, '');
			const presentVersion = (version + '').replace(/\./gi, '');
			if (os === 'android') {
				if (prevAndVersion > presentVersion) {
					window.HybridApp.getAppCarInfo(rgsid, userid, sellernum);
				} else {
					window.HybridApp.getAppCarInfo(rgsid, userid, sellernum, wtHitCase);
				}
			} else if (os === 'ios') {
				window.location = `${iosJsScheme}getAppCarInfo:${rgsid}:${userid}:${sellernum}:${wtHitCase}`;
			}
		},
		openChatRoom: function (rgsid, chatid) {
			var appVersion = version + '';
			appVersion = appVersion.replace(/\./gi, '');

			if (os == 'android') {
				var checkVersion = '2.4.5'.replace(/\./gi, '');
				if (appVersion < checkVersion) {
					if (confirm('앱 업데이트 후 확인하실 수 있습니다.\n업데이트하시겠습니까?')) {
						location.href = 'market://details?id=com.encar.encarMobileApp';
					} else {
						return true;
					}
				} else {
					window.HybridApp.openChatRoom(rgsid, chatid);
				}
			} else {
				var checkVersion = '2.1.4'.replace(/\./gi, '');
				if (appVersion < checkVersion) {
					alert('앱 업데이트 후 사용 가능합니다.');
					return true;
				} else {
					window.location = iosJsScheme + 'openChatRoom:' + rgsid + ':' + chatid;
					return false;
				}
			}
		},
		inquiryDateList: function () {
			if (os == 'android') {
				window.HybridApp.goInquiryList();
			} else {
				window.location.href = `${encarURL}/my/my_index.do?method=buyInquiryDateList`;
			}
		},
		getAppUuid: function () {
			if (os == 'android') {
				window.HybridApp.getAppUuid();
			} else {
				window.location = iosJsScheme + 'getAppUuid';
			}
		},
		beforeOpenAlert: function () {
			var checkVersion = '2.1.4'.replace(/\./gi, '');
			var appVersion = version + '';
			appVersion = appVersion.replace(/\./gi, '');

			if (os == 'ios' && appVersion < checkVersion) {
				alert('앱 업데이트 후 사용 가능합니다.');
				return true;
			} else {
				window.location.href = `${encarURL}/ca/cardetail.do?method=authDirect`;
				return false;
			}
		},
		goParamRun: function (r_param, r_redirect) {
			r_param = decodeURIComponent(r_param);
			r_redirect = decodeURIComponent(r_redirect);
			jQuery.getScript('/js/encarapp/lib/require.js', function () {
				requirejs.config({
					baseUrl: '/js/encarapp',
					paths: {
						ko: 'lib/knockout-3.3.0',
						'ko-switch': 'lib/knockout/switch-case/knockout-switch-case.min',
						'jquery-broker': 'helper/jquery-broker',
						'ko-broker': 'helper/ko-broker',
					},
					map: {
						'*': {
							jquery: 'jquery-broker',
							ko: 'ko-broker',
						},
						'jquery-broker': {
							jquery: 'jquery',
						},
						'ko-broker': {
							ko: 'ko',
						},
						'ko-switch': {
							knockout: 'ko',
						},
					},
				});
				requirejs(['/js/encarapp/module/recent/recent.all.js'], function (RP) {
					var param = JSON.parse(r_param);
					param.title = decodeURIComponent(param.title);
					new RP.SearchNavigation().addAndAppSync(param, function () {
						location.href = r_redirect;
					});
				});
			});
		},

		recentSearchRemoveItem: function (id) {
			var itemList = getRecentItem();
			var resultList = removeByKey(itemList, id);
			storage && storage.setItem(storageName, JSON.stringify(itemList));
			itemList = getRecentItem();
			this.searchOptionData(itemList, function () {});
		},

		carSearchChangeSort: function (sortType, flag) {
			var appVersion = version + '';
			appVersion = appVersion.replace(/\./gi, '');

			try {
				if (os == 'android') {
					var checkVersion = '2.4.5'.replace(/\./gi, '');
					if (appVersion < checkVersion) {
						if (confirm('앱 업데이트 후 확인하실 수 있습니다.\n업데이트하시겠습니까?')) {
							location.href = 'market://details?id=com.encar.encarMobileApp';
						} else {
							return true;
						}
					} else {
						window.HybridApp.carSearchChangeSort(sortType, flag);
					}
				} else {
					var checkVersion = '2.1.4'.replace(/\./gi, '');
					if (appVersion < checkVersion) {
						alert('앱 업데이트 후 확인하실 수 있습니다.\n업데이트하시겠습니까?');
						return true;
					} else {
						// window.location = iosJsScheme + "carSearchChangeSort:" + sortType + ":" + flag;
						return false;
					}
				}
			} catch (e) {}
		},

		setVisibleIndexEventLayer: function (layerType) {
			var appVersion = version + '';
			appVersion = appVersion.replace(/\./gi, '');

			try {
				if (os == 'android') {
					var checkVersion = '2.4.5'.replace(/\./gi, '');
					if (appVersion < checkVersion) {
						if (confirm('앱 업데이트 후 확인하실 수 있습니다.\n업데이트하시겠습니까?')) {
							location.href = 'market://details?id=com.encar.encarMobileApp';
						} else {
							return true;
						}
					} else {
						window.HybridApp.setVisibleIndexEventLayer(layerType);
					}
				} else {
					var checkVersion = '2.1.4'.replace(/\./gi, '');
					if (appVersion < checkVersion) {
						alert('앱 업데이트 후 확인하실 수 있습니다.\n업데이트하시겠습니까?');
						return true;
					} else {
						window.location = iosJsScheme + 'setVisibleIndexEventLayer:' + layerType;
						return false;
					}
				}
			} catch (e) {}
		},

		getEncarpayLimitCheck: function ({ carId, clientName, carMaximumLimit, creditMaximumLimit, expiredAt, interestRate }) {
			if (os === 'android') {
				if (window.HybridApp.getEncarpayLimitCheck === undefined) return;
				window.HybridApp.getEncarpayLimitCheck(carId, clientName, carMaximumLimit, creditMaximumLimit, expiredAt, interestRate);
			} else if (os === 'ios') {
				window.location = `${iosJsScheme}getEncarpayLimitCheck:${carId}:${clientName}:${carMaximumLimit}:${creditMaximumLimit}:${expiredAt}:${interestRate}`;
			}
		},

		/**
		 * 앱 탭바 hide 처리
		 */
		hideTabBar: function () {
			try {
				if (os == 'android') {
					window.HybridApp.hideTabBar();
				} else if (os == 'ios') {
					window.location = iosJsScheme + 'hideTabBar';
				}
			} catch (e) {}
		},
		/**
		 * 앱 탭바 show 처리
		 */
		showTabBar: function () {
			try {
				if (os == 'android') {
					window.HybridApp.showTabBar();
				} else if (os == 'ios') {
					window.location = iosJsScheme + 'showTabBar';
				}
			} catch (e) {}
		},
		/**
		 * iOS 뒤로가기 hide 처리
		 */
		hideBackButton: function () {
			try {
				if (os == 'ios') {
					window.location = iosJsScheme + 'hideBackButton';
				}
			} catch (e) {}
		},
		/**
		 * iOS 뒤로가기 show 처리
		 */
		showBackButton: function () {
			try {
				if (os == 'ios') {
					window.location = iosJsScheme + 'showBackButton';
				}
			} catch (e) {}
		},
		/**
		 * 당겨서 새로고침 enabled/disabled 설정
		 */
		setEnabledPullToRefresh: function (enabled) {
			try {
				if (os == 'android') {
					if (window.HybridApp.pullToRefresh) {
						window.HybridApp.pullToRefresh(enabled);
					}
				} else if (os == 'ios') {
					window.location = iosJsScheme + 'pullToRefresh:' + enabled;
				}
			} catch (e) {}
		},
		goNativeWindow: function (url, method, param, isReload) {
			try {
				if (os == 'android') {
					window.HybridApp.goNativeWindow(url, method, param, isReload);
				} else if (os == 'ios') {
					window.location = iosJsScheme + 'goNativeWindow:' + url + ':' + method + ':' + param + ':' + isReload;
				}
			} catch (e) {}
		},
		/**
		 * 마이페이지 최근검색
		 */
		recentSearch: function () {
			var appVersion = version + '';
			appVersion = appVersion.replace(/\./gi, '');

			try {
				if (os == 'android' && appVersion >= '4.3.6'.replace(/\./gi, '')) {
					window.HybridApp.recentSearch();
				} else if (os == 'ios' && appVersion >= '3.2.5'.replace(/\./gi, '')) {
					window.location = iosJsScheme + 'recentSearch';
				} else {
					window.location = '/my/my_index.do?method=viewRecentsearch';
				}
			} catch (e) {}
		},
		/**
		 * 웹뷰 닫기
		 */
		destroyWebView: function () {
			try {
				if (isEncarPartner) {
					if (os == 'android') {
						Noah?.destroyWebView?.();
					}
					if (os == 'ios') {
						window.webkit?.messageHandlers?.destroyWebView?.postMessage?.('');
					}
					return;
				}

				if (os == 'android') {
					window.HybridApp.destroyWebView();
				} else if (os == 'ios') {
					window.location = iosJsScheme + 'destroyWebView';
				} else {
					window.close();
				}
			} catch (e) {}
		},
		/**
		 * 새창 닫기
		 */
		destroyNativeWindow: function (param) {
			try {
				if (os == 'android') {
					window.HybridApp.destroyNativeWindow(param);
				} else {
					window.close();
				}
			} catch (e) {}
		},
		/**
		 * 중고차론 대출 개월 수, 선납금 전달
		 */
		setLoanIndexInfo: function (info) {
			try {
				if (os == 'android') {
					window.HybridApp.setLoanIndexInfo(info);
				} else if (os == 'ios') {
					window.location = iosJsScheme + 'setLoanIndexInfo:' + btoa(info);
				}
			} catch (e) {}
		},
		/**
		 * 웹에서 로그인 후에 앱에 알리기 위한 호출
		 */
		loginComplete: function (platform, token, toUrl) {
			try {
				if (os == 'android') {
					window.HybridApp.loginComplete(JSON.stringify({ platform, token, returnUrl: toUrl }));
				} else if (os == 'ios') {
					if (userAgent().lessThanAppVersion('4.1.0')) return false;
					window.location = iosJsScheme + 'loginComplete:' + platform + ':' + token + ':' + encodeURIComponent(toUrl);
				}
				return true;
			} catch (e) {
				return false;
			}
		},
		/**
		 * 안드로이드 앱에서 callback url 이용시 호출하기 위한 함수
		 */
		appleLoginComplete: function (token) {
			try {
				if (os == 'android') {
					return window.HybridApp.appleLoginComplete(token);
				}
				return true;
			} catch (e) {
				return false;
			}
		},
		/**
		 * 구글인증 화면 호출
		 */
		verifyGoogle: function () {
			try {
				if (os == 'android') {
					window.HybridApp.verifyGoogle();
				} else if (os == 'ios') {
					if (userAgent().lessThanAppVersion('4.1.0')) return false;
					window.location = iosJsScheme + 'verifyGoogle';
				}
				return true;
			} catch (e) {
				return false;
			}
		},
		/**
		 * 애플인증 화면 호출
		 */
		verifyApple: function () {
			try {
				if (os == 'android') {
					window.HybridApp.verifyApple();
				} else if (os == 'ios') {
					window.location = iosJsScheme + 'verifyApple';
				}
				return true;
			} catch (e) {
				return false;
			}
		},
		/**
		 * 사용자 정보 갱신
		 */
		refreshUserInfo: function (successUrl) {
			try {
				if (os == 'android') {
					window.HybridApp.refreshUserInfo(successUrl);
				} else if (os == 'ios') {
					if (userAgent().lessThanAppVersion('4.1.0')) return false;
					window.location = iosJsScheme + 'refreshUserInfo:' + encodeURIComponent(successUrl);
				}
				return true;
			} catch (e) {
				return false;
			}
		},

		/**
		 * 안드로이드 OTP 문자 발송시 호출함수
		 */
		openSmsRetriever: function () {
			try {
				if (os == 'android') {
					window.HybridApp.openSmsRetriever();
				}
			} catch (e) {}
		},

		/**
		 * AppsFlyer
		 */
		sendAppsflyerEvent(eventName) {
			try {
				if (os === 'android') {
					window.HybridApp.sendAppsflyerEvent(eventName);
				} else if (os === 'ios') {
					window.webkit.messageHandlers.event.postMessage(eventName);
				}
			} catch (e) {
				return false;
			}
		},

		/**
		 * 당신의 다음차 에상 대출 견적 화면 전환
		 */
		goLoanEstimate: function () {
			try {
				if (os == 'android') {
					window.HybridApp.goLoanEstimate();
				} else if (os == 'ios') {
					window.location = iosJsScheme + 'goLoanEstimate';
				}
			} catch (e) {
				return false;
			}
		},

		/**
		 * 최상단 스크롤 버튼 노출/비노출
		 */
		setVisibleTopBtn: function (visible) {
			try {
				if (os == 'android') {
					window.HybridApp.setVisibleTopBtn(visible);
				}
			} catch (e) {
				return false;
			}
		},

		/**
		 * 앱실행
		 */
		appLauncher: function (appUrl) {
			if (appCheck.isAndroidBrowser == true) {
				var url =
					'Intent://rs_sell?key=' +
					appUrl +
					'#Intent;scheme=encarapp;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=com.encar.encarMobileApp;end';
				window.location.replace(url);
				return;
			}
			if (appCheck.isIosBrowser == true) {
				location.href = 'encarapp://goweburl?url=' + appUrl;
				setTimeout(function () {
					window.location.replace('http://itunes.apple.com/kr/app/id404512755?mt=8');
				}, 1000);
				return;
			}
		},

		/**
		 * 앱다운로드
		 */
		appDownload: function (appUrl) {
			if (appCheck.isAndroidBrowser == true) {
				window.location.replace('https://play.google.com/store/apps/details?id=com.encar.encarMobileApp');
				return;
			}
			if (appCheck.isIosBrowser == true) {
				window.location.replace('http://itunes.apple.com/kr/app/id404512755?mt=8');
				return;
			}
		},
		isGoogleRelease: function () {
			try {
				if (os == 'android') {
					return window.HybridApp.isGoogleRelease(); // return boolean
				}
			} catch (e) {}
		},
		/**
		 * 모바일 팀에서 결제 목록 구성을 위한 용도,호출만 하면 됨
		 * @param {*} paymentType {carType,categoryType}
		 * carType : 'CAR_IMPORT' : 'CAR_DOMESTIC'
		 * categoryType : 현재 SELF만 사용, 다른 상품일때는 BE에 카테고리 타입문의해야
		 */
		readyGoogleInappBilling: function (paymentType) {
			try {
				if (os == 'android') {
					window.HybridApp.readyGoogleInappBilling(paymentType);
				}
			} catch (e) {}
		},
		/**
		 * 모바일진단앱에서 차량검수완료후 웹예약리스트 갱신
		 */
		setSavedNativeCarInfo: function () {
			if (window.DiagnosisApp?.setSavedNativeCarInfo === undefined) return;
			window.DiagnosisApp.setSavedNativeCarInfo();
		},
		/**
		 * 인풋 아이디를 전달하면 그 네이티브 코드로 인풋에 포커스를 잡아 vitual keyboard를 오픈시킨다
		 * @param (string) inputId
		 */
		inputFocusWithKeyboardUp: function (inputId) {
			const jsFocus = () => {
				// old Version 대응
				const $dom = document.getElementById(inputId);
				if ($dom) $dom.focus();
			};

			try {
				if (os == 'android') {
					if (userAgent().lessThanAppVersion('6.5.9')) {
						jsFocus();
					} else {
						window?.HybridApp?.showKeyboardInputText?.(inputId);
					}
				} else if (os === 'ios') {
					if (userAgent().lessThanAppVersion('5.5.2')) {
						jsFocus();
					} else {
						window?.webkit?.messageHandlers?.showKeyboardInputText?.postMessage?.(inputId);
					}
				} else {
					jsFocus();
				}
			} catch (e) {}
		},
		/**
         * 구글 API 사용하는 외부 결제 호출 브릿지
         * body:{
                productId:string,
                inappCallbackName:string,
                externalCallbackName: string,
            }
        */
		launchBillingFlow: function (body) {
			window?.HybridApp?.launchBillingFlow?.(JSON.stringify(body));
		},
	};
};

export default mobileAppBridge;
